<ion-item-divider color="light">
    <ion-label>{{ collectionDefinition.collectionName }}</ion-label>
    <ion-button *ngIf="canShowDeleteButton" (click)="deleteCollection()" fill="clear" slot="end">
        <ion-icon color="dark" slot="icon-only" name="remove-circle"></ion-icon>
    </ion-button>
</ion-item-divider>